import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from "recharts";

const fmtDay = (d) => new Date(`${d}T00:00:00Z`).toLocaleDateString(undefined, { weekday: "short", day: "numeric", timeZone: "UTC" });

export const SpendChart = () => {
  const { data } = useQuery({ queryKey: ["studio-spend-report"], queryFn: () => api.get("/admin/creative/spend-report?days=7").then(r => r.data) });
  if (!data) return null;
  const rows = data.days.map(r => ({ ...r, label: fmtDay(r.day) }));
  return (
    <article className="panel full-span" data-testid="spend-chart-panel">
      <div className="panel-head">
        <div><span className="eyebrow">SPEND REPORT</span><h2>Last 7 days</h2></div>
        <div className="legend spend-legend">
          <span data-testid="spend-total-live"><i className="cyan" />Live video ${data.totals.live_video_usd.toFixed(2)}</span>
          <span data-testid="spend-total-ai"><i className="pink" />OpenRouter AI ${data.totals.ai_usd.toFixed(2)}</span>
        </div>
      </div>
      <div style={{ height: 260 }} data-testid="spend-chart">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={rows}>
            <CartesianGrid stroke="#222836" vertical={false} />
            <XAxis dataKey="label" tickLine={false} axisLine={false} />
            <YAxis tickLine={false} axisLine={false} tickFormatter={v => `$${v}`} width={50} />
            <Tooltip cursor={{ fill: "rgba(255,255,255,.03)" }} contentStyle={{ background: "#11151e", border: "1px solid #343d4d", borderRadius: 7 }} formatter={(v, n) => [`$${Number(v).toFixed(4)}`, n]} />
            <Bar dataKey="live_video_usd" name="Live video" stackId="s" fill="var(--cyan)" />
            <Bar dataKey="ai_usd" name="OpenRouter AI" stackId="s" fill="var(--pink)" radius={[4, 4, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </article>
  );
};
